<template>
  <div id='RegisterByDay'></div>
</template>

<script>
import G2 from '@antv/g2';
import chartMixin from '../../chartMixin';

export default {
  name: 'RegisterByDay',
  mixins: [chartMixin],
  data() {
    return {
      demoData: [{ days: 1, count: 10 }],
    };
  },
  methods: {
    initData() {
      this.chart = new G2.Chart({
        container: 'RegisterByDay',
        forceFit: true,
        height: this.height,
        padding: [40, 20, 30, 50],
      });
      this.chart
        .source(this.data, {
          days: {
            min: 1,
            max: 31,
            type: 'linear',
            tickCount: 31,
          },
          count: {
            alias: '人数',
            formatter: val => {
              if (/\./.test(val)) {
                return '';
              }
              return val;
            },
          },
        })
        .tooltip({
          showTitle: false,
        })
        .line()
        .position('days*count');
      this.chart.line().position('days*count');
      this.chart.render();
    },
  },
};
</script>

